import { Injectable } from '@angular/core';
import { PHModal } from '../modal/phmodal';
import { BaseService } from '../../../core/service/base-service';
import { HttpClient } from '@angular/common/http';
import { AuthUtilsService } from '../../../core/util/auth-utils.service';

@Injectable({
  providedIn: 'root',
})
export class PHService extends BaseService<PHModal> {
  pagination: { pageIndex: number; perPage: number };
  constructor(http: HttpClient, authService: AuthUtilsService) {
    super(http, authService);
  }

  getModuleName(): string {
    return 'chemical/ph';
  }

  validate(): boolean {
    return false;
  }
}
